import { z } from 'zod';

export const API_TOKEN_MAX_DAYS = 90;
export const API_TOKEN_SCOPE_MCP_READ = 'mcp:read';

export const CreateApiTokenSchema = z.object({
  name: z.string().trim().min(1).max(100),
  expiresInDays: z.number().int().min(1).max(API_TOKEN_MAX_DAYS).default(API_TOKEN_MAX_DAYS),
});
export type CreateApiToken = z.infer<typeof CreateApiTokenSchema>;

export const ApiTokenSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  tokenPrefix: z.string(),
  scopes: z.array(z.string()),
  expiresAt: z.string(),
  lastUsedAt: z.string().nullable(),
  revokedAt: z.string().nullable(),
  createdAt: z.string(),
  userId: z.string().guid(),
  userEmail: z.string(),
});
export type ApiToken = z.infer<typeof ApiTokenSchema>;

/** Only the create response carries the raw token, exactly once. */
export const CreatedApiTokenSchema = ApiTokenSchema.extend({ token: z.string() });
export type CreatedApiToken = z.infer<typeof CreatedApiTokenSchema>;
